export const ADMIN_EMAIL = 'admin@memo.fun';
export const LEGAL_EMAIL = 'legal@memo.fun';
